<template>
  <b-container>
    <b-row class="justify-content-center">
      <b-col md="6" v-if="health_show" cols='12' sm="6">
        <div class="d-flex justify-content-center text-center" >
          <radial-progress-bar
          class="progressbar"
            :strokeWidth="4"
            :innerStrokeWidth="4"
            innerStrokeColor="#d3d3d3"
            startColor="#218ae5"
            stopColor="#218ae5"
            :diameter="40"
            :completed-steps="nullCatch(health)"
            :total-steps="health_max"
          >
            <img
              src="@/assets/images/icons/running_man_blue_small.png"
              v-if="health != 'Locked' && health != null && health != 0"
            />
            <img
              src="@/assets/images/icons/padlock.png"
              height="11px"
              width="9px"
              v-if="health == 'Locked' || health == null || health == 0"
            />
          </radial-progress-bar>
          <span v-if="!(health == 'Locked' || health == null || health == 0)" class="my-auto grey-text percent-progress">

          {{ nullCatch(health) }}%
          </span>
        </div>
      </b-col>
      <b-col md="6" v-if="money_show" cols='12' sm="6" >
        <div class="d-flex justify-content-center"  >
          <radial-progress-bar
          class="progressbar"
            :strokeWidth="4"
            :innerStrokeWidth="4"
            innerStrokeColor="#d3d3d3"
            startColor="#ed426f"
            stopColor="#ed426f"
            :diameter="40"
            :completed-steps="nullCatch(money)"
            :total-steps="money_max"
          >
            <img
              src="@/assets/images/icons/padlock.png"
              height="11px"
              width="9px"
              alt=""
              srcset=""
              v-if="money == 'Locked' || money == null || money == 0"
            />
            <img
              src="@/assets/images/icons/wallet_pink.png"
              alt=""
              v-if="money != 'Locked' && money != null && money != 0"
              srcset=""
            />
          </radial-progress-bar>
           <span v-if="!(money == 'Locked' || money == null || money == 0)" class="my-auto grey-text percent-progress">
          {{ nullCatch(money) }}%
           </span>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import RadialProgressBar from "vue-radial-progress";
export default {
  components: {
    RadialProgressBar,
  },
  props: [
    "health",
    "money",
    "health_show",
    "money_show",
    "health_max",
    "money_max",
  ],
  methods: {
    nullCatch(item) {
      return item != "Locked" && item != null ? parseInt(item) : 0;
    },
  },
};
</script>

<style>
</style>